import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {getUrlParameters} from '../../common/util/urlParameters';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const fecthCouriersList = () => apiActionCreator({
  'endpoint': '/transport/courier',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_COURIERS_LIST,
    ActionTypes.FETCHED_COURIERS_LIST,
    [
      ActionTypes.FETCHED_COURIERS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fecthTransportistList = (params) => apiActionCreator({
  'endpoint': `/transport/driver${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_TRANSPORTIST_LIST,
    ActionTypes.FETCHED_TRANSPORTIST_LIST,
    [
      ActionTypes.FETCHED_TRANSPORTIST_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateTransportist = (data, params) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/transport/driver',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_TRANSPORTIST_LIST,
      [
        {
          'type': ActionTypes.UPDATED_TRANSPORTIST_LIST,
        },
        (response) => {
          dispatch(fecthTransportistList(params));
          dispatch(buildSuccessMessage(response, response.message));
        },
      ],
      [
        ActionTypes.UPDATED_TRANSPORTIST_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  }));
};

export const deleteTransportist = (driverCode, params) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/transport/driver/${driverCode}`,
    'authenticated': true,
    'types': [
      ActionTypes.DELETING_TRANSPORTIST,
      [
        {
          'type': ActionTypes.DELETED_TRANSPORTIST,
        },
        (response) => {
          dispatch(fecthTransportistList(params));
          dispatch(buildSuccessMessage(response, response.message));
        },
      ],
      [
        ActionTypes.DELETED_TRANSPORTIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'DELETE',
    'contentType': 'application/json',
  }));
};

export const updateCourier = (data, params) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/transport/courier',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_COURIER,
      [
        {
          'type': ActionTypes.UPDATED_COURIER,
        },
        (response) => {
          dispatch(fecthCouriersList(params));
          dispatch(buildSuccessMessage(response, response.message));
        },
      ],
      [
        ActionTypes.UPDATED_COURIER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  }));
};

export const deleteCourier = (courierCode, params) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/transport/courier/${courierCode}`,
    'authenticated': true,
    'types': [
      ActionTypes.DELETING_COURIER,
      [
        {
          'type': ActionTypes.DELETED_COURIER,
        },
        (response) => {
          dispatch(fecthCouriersList());
          dispatch(fecthTransportistList(params));
          dispatch(buildSuccessMessage(response, response.message));
        },
      ],
      [
        ActionTypes.DELETED_COURIER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'DELETE',
    'contentType': 'application/json',
  }));
};

export const fetchDealersAgencies = () => apiActionCreator({
  'endpoint': '/transport/dealer-agency',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_DEALERS_AGENCIES_LIST,
    ActionTypes.FETCHED_DEALERS_AGENCIES_LIST,
    [
      ActionTypes.FETCHED_DEALERS_AGENCIES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateTransportistAgencies = (data, params) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/transport/driver-agency',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_DEALERS_AGENCIES_LIST,
      [
        {'type': ActionTypes.UPDATED_DEALERS_AGENCIES_LIST},
        (response) => {
          dispatch(fecthTransportistList(params));
          dispatch(buildSuccessMessage(response, response.message));
        },
      ],
      [
        ActionTypes.UPDATED_DEALERS_AGENCIES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  }));
};

export const exportToExcelCouriers = () => apiActionCreator({
  'endpoint': '/transport/courier/excel',
  'authenticated': true,
  'types': [
    ActionTypes.EXPORTING_TO_EXCEL_COURIERS,
    ActionTypes.EXPORTED_TO_EXCEL_COURIERS,
    [
      ActionTypes.EXPORTED_TO_EXCEL_COURIERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const exportToExcelTransportists = () => apiActionCreator({
  'endpoint': '/transport/driver/excel',
  'authenticated': true,
  'types': [
    ActionTypes.EXPORTING_TO_EXCEL_TRANSPORTISTS,
    ActionTypes.EXPORTED_TO_EXCEL_TRANSPORTISTS,
    [
      ActionTypes.EXPORTED_TO_EXCEL_TRANSPORTISTS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});


export const cleanTransportistUrl = () => ({
  'type': ActionTypes.CLEAN_TRANSPORTIST_EXPORT_URL,
});

